export const actionStruct = (type, payload = {}) => ({ type, payload });
